import * as ActionTypes from '../ActionTypes';

export const InitializeFaceApiModelsAction = () => {
  return {
    type: ActionTypes.FACEAPI_LOAD_REQUEST,
  };
};
